/**
 * Température commerciale d'un devis (chances de signature), pour la prod et le service.
 * Valeurs : GroupedOrder::TEMPERATURES côté API (CHAUD / TIEDE / FROID).
 * Partagée entre le pipeline B2B et l'agenda des événements de service.
 */
export const TEMPERATURES = {
  CHAUD: { libelle: "🔥 Chaud", emoji: "🔥", couleur: "#d9534f" },
  TIEDE: { libelle: "🌤 Tiède", emoji: "🌤", couleur: "#f0ad4e" },
  FROID: { libelle: "❄️ Froid", emoji: "❄️", couleur: "#5bc0de" },
};
